import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppButton = () => {
  const phoneNumber = "916301898060"; // 👈 use digits only, no + or spaces
  const message = "Hi, I'm interested in your services!";

  const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappURL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition transform"
    >
      <FaWhatsapp size={28} />
    </a>
  );
};

export default WhatsAppButton;
